import { area as turfArea } from '@turf/turf';
import { type Feature } from 'ol';
import {
  type GeoJSONMultiPolygon,
  type GeoJSONPolygon,
} from 'ol/format/GeoJSON';
import { geoJSONEpsg3857 } from '../../../mapStyleUtils.ts';

/**
 * Calcola l'area di una feature arrotondandola.
 */
export function getRoundedFeatureArea(feature: Feature) {
  const geometry = feature.getGeometry();
  if (!geometry) return 0;

  const geomType = geometry.getType();
  if (geomType !== 'Polygon' && geomType !== 'MultiPolygon') return 0;

  const area = turfArea(
    geoJSONEpsg3857.writeFeatureObject(feature).geometry as
      | GeoJSONPolygon
      | GeoJSONMultiPolygon,
  );
  return Math.round((area + Number.EPSILON) * 100) / 100;
}
